export const FAILED = 'ScanCodeMFA/failed';
export const LOADING = 'ScanCodeMFA/loading';
export const SUCCESS = 'ScanCodeMFA/success';
